<template>
  <div class="filter-wrap">
    <router-link tag="div" to="/search/car-model" class="select-car" :class="{'selected': Brand}">{{Brand? Brand.name:'选择车系'}}<i class="iconfont icon-mjiantou"></i></router-link>
    <div class="group" v-if="all.tags">
      <!-- tags 后台数据字段 -->
      <div class="title">精确查找</div>
      <div class="list">
        <div class="item" :class="{active: quanbu}" @click="selectDefault">全部</div>
        <div class="item" v-for="item in all.tags" :key="item.id"
          :class="{active:item.id === (Tag && Tag.id)}" @click="selectTags(item)">{{item.name}}</div>
      </div>
    </div>
    <div class="group" v-if="all.activities">
      <!-- activities 后台数据字段 -->
      <div class="title">活动</div>
      <div class="list">
        <div class="item" v-for="item in all.activities" :key="item.id"
          :class="{active:item.id === (Activity && Activity.id)}" @click="selectActivities(item)">{{item.name}}</div>
      </div>
    </div>
    <div class="group" v-if="all.types">
      <!-- types 后台数据字段 -->
      <div class="title">课程形式</div>
      <div class="list">
        <div class="item" v-for="item in all.types" :key="item.id"
          :class="{active:item.id === (Type && Type.id)}" @click="selectTypes(item)">{{item.name}}</div>
      </div>
    </div>
    <div class="group" v-if="all.categories">
      <!-- categories 后台数据字段 -->
      <div class="title">热门分类</div>
      <div class="list">
        <div class="item" v-for="item in all.categories" :key="item.id"
          :class="{active:item.id === (Category && Category.id)}" @click="selectCategories(item)">{{item.name}}</div>
      </div>
    </div>
    <div class="op">
      <div @click="reset">重置</div>
      <div @click="$router.go(-1)">查看</div>
    </div>
  </div>
</template>

<script>
import {RES_OK} from '@/api/config'
import {mapFilter, Brand, Tag, Activity, Type, Category, getInitFilterData, resetFilter, pushFilter} from '@/api/search'
export default {
  data() {
    return {
      quanbu: false,
      all: {}
    }
  },
  created() {
    getInitFilterData().then(({data}) => {
      if (data && data.code === RES_OK) {
        this.all = data.data
      }
    })
  },
  computed: {
    ...mapFilter([Brand, Tag, Activity, Type, Category])
  },
  methods: {
    reset() {
      // 重置vuex里全局数据
      resetFilter()
    },
    selectTags(item) {
      // 精确查找
      pushFilter(Tag, item)
      this.quanbu = false
    },
    selectActivities(item) {
      // 活动
      pushFilter(Activity, item)
    },
    selectTypes(item) {
      // 课程形式
      pushFilter(Type, item)
    },
    selectCategories(item) {
      // 热门分类
      pushFilter(Category, item)
    },
    selectDefault() {
      // 精确查找的全部
      this.quanbu = true
      pushFilter(Tag)
    }
  }
}
</script>

<style scoped lang="stylus" ref="stylesheet/stylus">
  @import "~common/stylus/variable"
  .filter-wrap{
    padding: 0 size(30) size(120)
  }
  .select-car{
    color $color-theme
    text-align center
    font-size size(28)
    line-height size(72)
    border-radius size(38)
    border 1px solid $color-theme
    margin-top size(32)
    margin-bottom size(40)
    position relative
    padding 0 size(60)
    white-space nowrap
    overflow hidden
    text-overflow ellipsis
    .icon-mjiantou{
      position absolute
      right size(26)
      top 0
      line-height size(72)
      font-weight 800
      font-size 13px
    }
    &.selected{
      background $color-theme
      color #fff
    }
  }
  .group{
    .title{
      font-size size(32)
      font-weight 800
      margin size(20) 0 size(26)
    }
  }
  .list{
    &:after{
      content ' '
      display block
      height 0
      clear both
    }
    margin-left -3.4%
    .item{
      float left
      font-size size(28)
      color #0d0e0f
      min-width 29.6%
      margin-left 3.3%
      margin-bottom size(20)
      text-align center
      line-height size(72)
      height size(72)
      border-radius 3px
      padding 0 size(16)
      background #eeeef0
      &.active{
        background lighten($color-theme, 79%)
        border 1px solid $color-theme
      }
    }
  }
  .op{
    display table
    width 100%
    position fixed
    left 0
    bottom 0
    text-align center
    height size(100)
    box-shadow: 0 -1px 5px 2px rgba(0,0,0,0.06)
    font-size size(32)
    color #4d4c4c
    background #fff
    >div{
      display table-cell
      vertical-align middle
      &:last-child{
        color #ffffff
        background $color-theme
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/search/filter.vue